// sync-start:cookie-consent-categories 953236997 https://github.com/Khan/webapp/blob/master/pkg/web/cookie_consent.go
export enum CookieCategory {
    // Short of using browser settings to block all cookies, users cannot
    // opt out of Stricly Necessary cookies. These cookies are needed for core
    // functionality of our product -- e.g. authentication, consuming content,
    // and tracking progress.
    StrictlyNecessary = "STRICTLY_NECESSARY",

    // We use Performance cookies to better understand how users interact with
    // Khan Academy -- e.g. to gain visibility into usage trends or to measure
    // performance.
    Performance = "PERFORMANCE",

    // Functional cookies provide user-facing benefits, and the usefulness or
    // joy provided by certain features may be diminished without these
    // cookies. However, a cookie set for "functional" purposes is not
    // _required_ in order to experience the main benefits of KA. Examples of
    // setting a cookie for "functional" purposes include keeping a modal
    // dismissed or for referencing a user's settings.
    Functional = "FUNCTIONAL",

    // Targeting cookies are used for identifying or connecting with people who
    // may be interested in supporting our mission (e.g., identifying potential
    // donors for marketing purposes). Such cookies should not be set if the
    // user may be underage.
    Targeting = "TARGETING",
}
// sync-end:cookie-consent-categories

export type FeatureFlags = Record<string, boolean>;
